import BaseModel from "./BaseModel";
import { parseDate } from "../common/Hooks";
import { RaffleDrawAttributes } from "../attributes/raffle-draw-attributes";

class RaffleDraw extends BaseModel {
  id: number;
  raffle_draw_type: number;
  renew_losers: number;
  number_of_winners: number;
  raffle_draw_date: string | null;
  in_progress: boolean | null;
  ended_at: string | null;

  constructor(
    raffleDrawType: number,
    renewLosers: number,
    numberOfWinners: number,
    raffleDrawDate: string | null,
    inProgress: boolean | null,
    endedAt: string | null,
    createdAt: Date | null
  ) {
    super(createdAt);

    this.raffle_draw_type = raffleDrawType;
    this.renew_losers = renewLosers;
    this.number_of_winners = numberOfWinners;
    this.raffle_draw_date = raffleDrawDate;
    this.in_progress = inProgress;
    this.ended_at = endedAt;
  }

  static fromJson(json: RaffleDrawAttributes): RaffleDraw | null {
    if (json === null || json === undefined) {
      return null;
    }

    return new RaffleDraw(
      json.raffle_draw_type,
      json.renew_losers,
      json.number_of_winners,
      json.raffle_draw_date,
      json.in_progress,
      json.ended_at,
      parseDate(json.created_at)
    );
  }
}

export default RaffleDraw;
